import React, {useState, useEffect} from 'react';
import * as S from './SuppportingInfo.styles';
import {useSelector, useDispatch} from 'react-redux';
import {createSelector} from 'reselect';
import {profileInfoSelector, supportInfoDataSelector} from '@ibibo/myaccount-reducer';
import {sendEvarData} from '@ibibo/analytics';
import {useHistory} from 'react-router-dom';

import {validations} from '../../../../../utils/validations';

const SupportingInfo = ({}) => {
  const profileInfo = useSelector(supportInfoDataSelector);

  return (
    <S.ProfileMainWrap>
      <S.ProfileInnerWrap>
        <S.ProfileHeadOuterWrap>
          <S.ProfileHeadInnerWrap>
            <S.HeadMainText>{profileInfo?.heading}</S.HeadMainText>
            <S.HeadSubText>{profileInfo?.sub_heading}</S.HeadSubText>
          </S.ProfileHeadInnerWrap>
        </S.ProfileHeadOuterWrap>
        {profileInfo?.key_list?.length &&
          profileInfo?.key_list.map((item, key) => {
            return (
              profileInfo[item]?.value && (
                <S.ProfileInfoOuterWrap key={key}>
                  <S.ProfileInfoInnerWrap>
                    <S.InfoTitleWrap>
                      <S.TitleText>{profileInfo[item]?.key}</S.TitleText>
                    </S.InfoTitleWrap>
                    <S.InfoTextWrap>
                      <S.InfoText>{profileInfo[item]?.value}</S.InfoText>
                      <S.InfoSubText>{profileInfo[item]?.row_subtitle}</S.InfoSubText>
                    </S.InfoTextWrap>
                  </S.ProfileInfoInnerWrap>
                </S.ProfileInfoOuterWrap>
              )
            );
          })}
      </S.ProfileInnerWrap>
    </S.ProfileMainWrap>
  );
};

export default SupportingInfo;
